var _rect, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg400X200(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#ddd"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    fontFamily: "sans-serif",
    fontSize: 20,
    fill: "#000",
    textAnchor: "middle"
  }, "400 x 200")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg400X200);
export default __webpack_public_path__ + "static/media/400x200.448c77f1bb74b57550abe3f79fcd25bc.svg";
export { ForwardRef as ReactComponent };